import { render, staticRenderFns } from "./instructionsPop.vue?vue&type=template&id=4a549666&scoped=true&"
import script from "./instructionsPop.vue?vue&type=script&lang=js&"
export * from "./instructionsPop.vue?vue&type=script&lang=js&"
import style0 from "./instructionsPop.vue?vue&type=style&index=0&id=4a549666&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a549666",
  null
  
)

export default component.exports